export const initialState = {
  publishSurveys: []
};
